<script>
/**
 * ReporteAgrupadoPorUsuario
 * 
 * @author Daniel Lepe
 * @date Oct 17th, 2025
 * @version 1.0
 */
import _ from 'lodash'
import { captions, quicktableFilters, baseIndex as fetchingAPI } from './archetype.js'
import { objectToUrlString } from '@/utils.js'

import QuickCardFooter from '@/views/elements/quick-card-footer.vue'
import axios from 'axios'
import automodal from './CocinareporteinterrelacionAutomodal.vue'

let name = 'ReporteAgrupadoPorUsuario',
	newButtonLabel = 'New',
	emptyHeader = 'Data not found',
	emptyLead = 'Module empty',
	reloadData = 'Try reloading this page',
	tryAgainLater = '',
	header = null,
	footer = null;

function extractPlanNames(items) {
	return _.uniq(_.map(items, 'plan')).filter(Boolean);
}
function processItems(items) {
	// Group items by usuario_id_pk
	return _.chain(items)
		.groupBy('usuario_id_pk')
		.map((userItems, userId) => {
			const firstItem = userItems[0];
			console.log('firstItem', firstItem)

			// Get all plans for this user and calculate subtotal
			const planesChained = _.chain(userItems)
				.groupBy('plan')
				.mapValues(planItems => ({
					cantidad: _.sumBy(planItems, item => parseInt(item.cantidad)),
					precio: _.sumBy(planItems, item => parseInt(item.precio))
				}))
				.value();
			console.log('planesChained', planesChained)
			let planes = {},
				precio = 0;
			_.forEach(planesChained, (pChain, val) => {
				planes[val] = pChain.cantidad;
				precio += (pChain.precio);
			})

			// Return formatted user object
			return {
				usuario_id_pk: userId,
				cliente: firstItem.cliente,
				sede: firstItem.sede,
				sede_tipo: firstItem.sede_tipo,
				codigo: firstItem.codigo,
				imagen_logo: firstItem.imagen_logo,
				precio,
				...planes,
			};
		})
		.value();
}

export default {
	name,

	components: {
		automodal,
		QuickCardFooter,
		// moduleNavigator
	},

	props: {
		debug: {
			type: Boolean,
			default: !true
		},
		columnizePlanes: {
			type: Boolean,
			default: false
		},
		hideSede: {
			type: Boolean,
			default: false
		},
		hideFilters: {
			type: Boolean,
			default: false
		},
		hidePlanName: {
			type: Boolean,
			default: false
		},
		value: {
			type: [Object, Number, String]
		},
		valueName: {
			type: String,
			default: 'id'
		},
		disableNew: {
			type: Boolean,
			default: true
		},
		selectMode: {
			type: Boolean,
			default: false
		},
		hideNavigation: {
			type: Boolean,
			default: false
		},
		fetchingAPI: {
			type: String,
			default: () => { return fetchingAPI }
		},
		header: {
			type: String,
			default: () => { return header }
		},
		perPage: {
			type: Number,
			default: 1000,
		},
		footer: {
			type: String,
			default: () => { return footer }
		},
		captions: {
			type: [Array, Object],
			default: () => captions
		},
		args: {
			type: Object,
			default: () => { return {} }
		}
	},

	computed: {
		getPlansSums() {
			const items = _.cloneDeep(this.items)

			// First group items by plan_id and sum their quantities
			const planTotals = _.groupBy(items, 'plan');

			// Create unique plans with subtotals
			return _.uniqBy(items.map(item => ({
				plan: item.plan,
				subtotal: _.sumBy(planTotals[item.plan], item => parseInt(item.cantidad)),
				subtotalPrecio: _.sumBy(planTotals[item.plan], item => parseInt(item.precio))
			})), 'plan');
		},
		cCaptions() {
			return [
					{ key: 'cliente', label: 'Cliente', sortable: true },
					{ key: 'sede', label: 'Sede', sortable: true },
					{ key: 'grupo', label: 'Grupo', sortable: true },
					// { key: 'codigo', label: 'Código', sortable: true },
					...Object.keys(this.planNamesRenamingReversed).map(planName => ({ 
						key: planName, 
						label: planName, 
						sortable: true,
						class: 'text-center nowrap'
					}))
				]
		},
		sourceURI() {
			let init = this.fetchingAPI + "/" + this.perPage + "/" + this.currentPage;
			try {
				if (this.term) {
					init += "/" + this.term;
				} else if (!this.term || this.term == "s") {
					init += "/@";
				}
				const fullArgs = _.merge(this.args, this.filters);
				init += '/' + objectToUrlString(fullArgs)
				return init.trim().replace(/[ ]/g, '_');
			} catch (e) {
				console.warn("sourceURI.building.error", init, e)
			}
			return init;
		},
		itemsGroupedByPlan() {
			return processItems(this.items)
		},
		planNamesRenaming() {

			// SAMPLE ["13 AL 17 COMIDAS SEMANA 42","DESAYUNO ADULTOS SEMANA 42","LA MESA LIBRE SEMANA 42","MENU K3 OTOÑO 13 AL 17 DE OCTUBRE","SEMANA 42 MEDITERRANEO","SEMANA 42 TRADICIONAL","SEMANA 42 VEGETARIANO"]

			try {

				const items = extractPlanNames(this.items);
				const planDefinitions = {};

				items.forEach(planName => {
					let definition = planName;
					
					if (planName.includes('COMIDAS')) {
						definition = 'COMIDAS';
					} else if (planName.includes('DESAYUNO') && planName.includes('ADULTOS')) {
						definition = 'DESAYUNO ADULTO';
					} else if (planName.includes('DESAYUNO')) {
						definition = 'DESAYUNO';
					} else if (planName.includes('MESA LIBRE')) {
						definition = 'MESA LIBRE';
					} else if (planName.includes('MENU') || planName.includes('OTOÑO') || planName.includes('AUTUMN') || planName.includes('CHRISTMAS') || planName.includes('NAVIDAD') || planName.includes('VERANO') || planName.includes('SUMMER') || planName.includes('INVIERNO') || planName.includes('WINTER') || planName.includes('PRIMAVERA') || planName.includes('SPRING') || planName.includes('ESPECIAL') || planName.includes('SPECIAL')) {
						definition = 'ESPECIAL';
					} else if (planName.includes('MEDITERRANEO')) {
						definition = 'MEDITERRANEO';
					} else if (planName.includes('TRADICIONAL')) {
						definition = 'TRADICIONAL';
					} else if (planName.includes('VEGETARIANO')) {
						definition = 'VEGETARIANO';
					} else {
						definition = 'OTHER';
					}
					
					planDefinitions[planName] = definition;

				});

				return planDefinitions;
			} catch (e) {
				console.error(e)
			}
		},
		planNamesRenamingReversed() {
			try {
				const reversed = {};
				Object.entries(this.planNamesRenaming).forEach(([originalName, renamedName]) => {
					if (!reversed[renamedName]) {
						reversed[renamedName] = [];
					}
					reversed[renamedName].push(originalName);
				});
				return reversed;
			} catch (e) {
				console.error(e);
				return {};
			}
		},
		itemsWithPlansRenamedAsColumns() {
			try {
				const items = _.cloneDeep(this.items);

				const users = _.chain(items)
					.groupBy('usuario_id_pk')
					.map((userItems) => {
						const firstItem = userItems[0];
						return {
							usuario_id_pk: firstItem.usuario_id_pk,
							cliente: firstItem.cliente,
							codigo: firstItem.codigo,
							grupo: firstItem.grupo,
							sede: firstItem.sede,
							sede_tipo: firstItem.sede_tipo
						};
					})
					.value();

				// Create usersCompound with plan totals for each user
				const usersCompound = users.map(user => {
					// Start with base user properties
					const userWithPlans = { ...user };
					
					// Initialize all plan names with 0
					Object.values(this.planNamesRenaming).forEach(renamedPlan => {
						userWithPlans[renamedPlan] = 0;
					});
					
					// Get all items for this user
					const userItems = items.filter(item => item.usuario_id_pk === user.usuario_id_pk);
					
					// Sum quantities for each plan
					userItems.forEach(item => {
						const originalPlanName = item.plan;
						const renamedPlan = this.planNamesRenaming[originalPlanName];
						if (renamedPlan) {
							userWithPlans[renamedPlan] += parseInt(item.cantidad) || 0;
						}
					});
					
					return userWithPlans;
				});

				return usersCompound;

				// return { users, items, usersCompound };
			} catch (e) {
				console.error(e)
			}
		}
	},

	data: () => {
		return {
			name, newButtonLabel, emptyHeader,
			emptyLead, tryAgainLater, reloadData,
			currentPage: 1,
			items: [
				// {
				//   lunch_planes_id: "814",
				//   fecha_pedido: "2025-10-17",
				//   plan: "MENU K3 OTOÑO 13 AL 17 DE OCTUBRE",
				//   sede: "CUMBRES SAN JAVIER",
				//   cliente: "LUIS MARIANO AMEZCUA",
				//   cantidad: "1",
				//   precio: "60.00",
				//   grupo: "2D-KINDER",
				//   plan_tipo: "base",
				//   usuario_id_pk: "3564",
				//   presencia_tipo: "alumno",
				//   lunch_usuariopresencia_id: "1546",
				//   sede_tipo: "escuela",
				//   imagen_logo: "https://api.supereasy.mx/storage/img/render/cee0998002cdd99933bbb6065ce5e619/3748",
				//   codigo: "CUMBRES-SJ-23",
				//   notas_alimentarias: ""
				// }
			],
			groupingDefinitions: {},
			itemsCount: 0,
			term: null, filters: {},
			isLoading: false,
			sortBy: '',
			sortDesc: false,
			
		}
	},

	methods: {
		isSelected(data) {
			// console.log('isSelected', data, this.value, (this.value == data.item[this.valueName]))
			return (this.value == data.item[this.valueName])
		},
		rowClicked(item, index, event) {
			this.$emit('setItem', item, event)
			this.$nextTick(() => {
				if (this.selectMode)
					this.$emit('input', item[this.valueName], { item, index, event })
			})
		},
		quicktableFilters,
		async refreshFromStart() {
			this.currentPage = 1
			this.refresh()
		},
		async refresh() {
			this.isLoading = true
			await this.loadUp()
			this.isLoading = false
		},
		async loadUp() {
			try {
				let response = await axios.get(this.sourceURI)
				this.items = response.data.rows;
				this.itemsCount = response.data.count;
				this.groupingDefinitions = (_.isObjectLike(response.groupingDefinitions) ? response.groupingDefinitions : {});
			} catch (error) {
				this.items = [];
				this.itemsCount = 0;
				console.error(error)
			}
		}
	},

	watch: {
		currentPage(a, b) {
			this.refresh();
		},
		'$route'() {
			this.loadUp()
		}
	},

	mounted() {
		this.refresh()
	}
};
</script>

<template>
	<div :id="name">

			<template v-if="debug">
				<div class="debug"><pre><code>{{ cCaptions }}</code></pre></div>
				<div class="debug"><pre><code>{{ planNamesRenaming }}</code></pre></div>
				<div class="debug"><pre><code>{{ planNamesRenamingReversed }}</code></pre></div>
				<div class="debug"><pre><code>{{ itemsWithPlansRenamedAsColumns[0] }}</code></pre></div>
			</template>
		<!-- <module-navigator class="mb-3" v-if="!hideNavigation" /> -->

		<b-card no-body>

			<!-- TABLE CONTENT -->
			<b-table responsive class="animated fadeIn" v-if="itemsWithPlansRenamedAsColumns.length && !isLoading" 
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:items="itemsWithPlansRenamedAsColumns" 
				:fields="cCaptions">

				<template #bottom-row>
					<b-td :colspan="Object.keys(cCaptions || {}).length - Object.keys(planNamesRenamingReversed).length" class="text-right">
						<strong>Total:</strong>
					</b-td>
					<b-td v-for="(planGroup, planName) in planNamesRenamingReversed" :key="planName" class="text-center">
						<strong>
							{{ itemsWithPlansRenamedAsColumns.reduce((sum, item) => sum + (parseInt(item[planName]) || 0), 0) }}
						</strong>
					</b-td>
				</template>

			</b-table>

			<template v-if="debug">
				<div class="debug"><pre><code>{{ itemsWithPlansRenamedAsColumns[0] }}</code></pre></div>
				<div class="debug"><pre><code>{{ Object.keys(itemsWithPlansRenamedAsColumns[0] || {}).length }}</code></pre></div>
				<div class="debug"><pre><code>{{ Object.values(planNamesRenamingReversed).length }}</code></pre></div>
				<div class="debug"><pre><code>{{ Object.keys(cCaptions || {}).length - Object.keys(planNamesRenamingReversed).length }}</code></pre></div>
			</template>

			<!-- LOADING SPINNER -->

			<div v-if="isLoading">
				<div class="text-center p-5">
					<b-spinner variant="primary" />
				</div>
			</div>

			<!-- EMPTY JUMBOTRON -->

			<div v-else-if="!items.length" class="pt-4 pl-4 pr-4 pb-0">
				<b-jumbotron :header="emptyHeader" :lead="emptyLead">
					<p>{{ tryAgainLater }}</p>
					<b-button variant="primary" @click="refresh()">{{ reloadData }}</b-button>
				</b-jumbotron>
			</div>

			<!-- HEADER -->

			<template v-slot:header>
				<b-row align-h="between">

					<b-col md="auto" v-if="!!header">
						<h6 class="mt-2 mb-2">{{ header }}</h6>
					</b-col>

					<template v-if="!hideFilters">
						<b-col class="hide-on-print">
							<b-input-group>
								<b-form-input v-model="term" @keyup.enter="refreshFromStart()"
									placeholder="Filtra en los resultados" />
								<b-input-group-append>
									<b-button v-if="!!term" variant="secondary"
										@click="term = ''; refreshFromStart();"><i class="fa fa-times"></i></b-button>
									<b-button variant="secondary" @click="refreshFromStart()" :disabled="!term"><i
											class="fa fa-search"></i></b-button>
								</b-input-group-append>
							</b-input-group>
						</b-col>
						<quicktable-filters v-model="filters" @changed="refreshFromStart" :filters="quicktableFilters"
							:groupingDefinitions="groupingDefinitions" class="hide-on-print" />
					</template>

					<b-col md="auto">
						<download-as-csv-button 
							:content="itemsWithPlansRenamedAsColumns" 
							:headers="cCaptions" 
							:file-name="header" />
					</b-col>

					<b-col md="auto" class="align-right">
						<automodal @refresh="refresh" :args="args" v-if="!disableNew">
							Nuevo
						</automodal>
					</b-col>

				</b-row>
			</template>

			<!-- FOOTER -->

			<template v-slot:footer v-if="!isLoading && items.length">
				<quick-card-footer v-model="currentPage" class="hide-on-print" 
					:items-count="itemsCount"
					:per-page="perPage" 
					:items-fetched="items.length" 
					@refresh="refresh" />
			</template>

		</b-card>

	</div>
</template>

<style lang="scss">
#ReporteAgrupadoPorUsuario {
	.notas_alimentarias {
		background-color: var(--light);
		color: var(--danger);
		font-size: 0.75em;
		border-radius: 0.25em;
	}

}
</style>